export enum ActionTypes {
  SET_SELECTED_INSTANCE_ID = 'APP/SET_SELECTED_INSTANCE_ID',
}

interface SetSelectedInstanceIdAction {
  type: ActionTypes.SET_SELECTED_INSTANCE_ID;
  instanceId: number;
}

export type InstanceActions = SetSelectedInstanceIdAction;
